declare namespace $ {

	type $shm_ba_agent_message_posts__table_shm_ba_agent_message_text_1 = $mol_type_enforce<
		ReturnType< $shm_ba_agent_message_text['posts_table'] >
		,
		ReturnType< $shm_ba_agent_message_posts['table'] >
	>
	type $mol_view__sub_shm_ba_agent_message_text_2 = $mol_type_enforce<
		ReturnType< $shm_ba_agent_message_text['posts_invalid_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_agent_message_text_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_agent_message_text extends $shm_agent_message_text {
		posts_table( id: any): any
		posts_invalid_rows( id: any): readonly(any)[]
		posts_error( id: any): string
		Posts( id: any): $shm_ba_agent_message_posts
		Posts_invalid( id: any): $mol_view
		Posts_error( id: any): $mol_view
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map